import ProductCard from "@/components/entities/product-card";
import Pager from "@/components/entities/pager";
import { ProductListResource } from "@/api/generated-api";
import { FC } from "react";
import ProductCardLoading from "@/components/entities/product-card/loading-card";
import { useStore } from "@/hooks/system/useStore";
import { observer } from "mobx-react-lite";
import { useTranslations } from "next-intl";
import S from "../index.module.scss";

interface IProductsList {
  products?: ProductListResource;
  loading: boolean;
}

const ProductsList: FC<IProductsList> = ({ products, loading }) => {
  const { selectedFilters, setSelectedFilters } = useStore("search");
  const t = useTranslations();

  const pageHandler = (page: number) => {
    setSelectedFilters({ pageNumber: page });
  };

  if (loading)
    return (
      <div className={S.productsGrid}>
        {new Array(12).fill({ id: 0 }).map((_, idx) => (
          <ProductCardLoading key={idx} />
        ))}
      </div>
    );

  return (
    <>
      {products && products?.total ? (
        <>
          <div className={S.productsGrid}>
            {products.products.map(product => (
              <ProductCard key={product.id} product={product} />
            ))}
          </div>
          <Pager
            activePageNumber={selectedFilters.pageNumber || 1}
            total={products.total}
            activePageSize={12}
            onPageChangeHandler={pageHandler}
          />
        </>
      ) : (
        <p className={S.notFoundText}>{t("noResults", { query: selectedFilters.q || "" })}</p>
      )}
    </>
  );
};

export default observer(ProductsList);
